module.exports = __webpack_public_path__ + "static/media/KH.9467ef4b.svg";